import { baseApi } from "configs/store-query";
import {
  AuthenticationPasswordSignInApiRequest,
  AuthenticationPasswordSignInApiResponse,
  AuthenticationPasswordSignUpApiRequest,
  AuthenticationPasswordSignUpApiResponse,
} from "apis/authentication/types/authentication-password-api";
import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryReturnValue,
} from "@reduxjs/toolkit/query";
import { AccountType } from "apis/account/enums/account-type";

const BASE_PATH = "/authentication/password";

export const authenticationPasswordApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signInPasswordAuthentication: build.mutation<
      AuthenticationPasswordSignInApiResponse,
      AuthenticationPasswordSignInApiRequest
    >({
      // query: (config) => ({
      //   url: `${BASE_PATH}/sign-in`,
      //   method: "POST",
      //   ...config,
      // }),
      queryFn: async (config, _, __, baseQuery) => {
        const queryResult = (await baseQuery({
          url: `${BASE_PATH}/sign-in`,
          method: "POST",
          ...config,
        })) as QueryReturnValue<
          AuthenticationPasswordSignInApiResponse,
          FetchBaseQueryError,
          FetchBaseQueryMeta
        >;

        if (queryResult.error) {
          return queryResult;
        }

        if (queryResult.data?.data?.account?.type !== AccountType.Admin) {
          return {
            error: {
              status: 400,
              data: {
                status: 400,
                message: "Invalid username or password",
                errors: [],
                name: "ValidationException",
                path: `${BASE_PATH}/sign-in`,
              },
            },
          };
        }

        return queryResult;
      },
    }),
    signUpPasswordAuthentication: build.mutation<
      AuthenticationPasswordSignUpApiResponse,
      AuthenticationPasswordSignUpApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-up`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
